import { mapGetters } from 'vuex'

import moment from 'moment'

export default {
  ...mapGetters('app/patient/agendas', [
    'filtersToSearch'
  ]),
  // Retornando a data por extenso  para o modal de agendamento.
  getDay () {
    moment.locale('pt')
    return moment(this.schedule.date_id).format('DD/MM/YYYY dddd')
  },
  speciality () {
    return this.agenda.specialities
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/form/resources/computed.js